import { Component, Input } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-header-customer-address",
  templateUrl: "./header-customer-address.component.html",
  styleUrls: ["./header-customer-address.component.scss"],
  imports: [
    ModalStackerComponent,
    ClientDetailsComponent,
    ReactiveFormsModule,
    InputTextModule,
  ],
})
export class HeaderCustomerAddressComponent {
  @Input() parent!: FormGroup;
  clientDisplayModal = false;
  clientId = "";

  redirectToClientSummary() {
    this.clientId = this.parent.get(["orderHeader", "customerId"])?.value;
    const name = this.parent.get(["customerAddress", "name"])?.value;
    if (name && this.clientId) {
      this.clientDisplayModal = true;
    }
  }

  closeModal() {
    this.clientDisplayModal = false;
  }
}
